import Cookies from 'js-cookie';
import axios from '@shared/config/baseAPI';

const deviceId = Cookies.get('deviceId'); // change this with your device id

export default async function verifyReCaptchaApi(token) {
  try {
    const formData = new FormData();
    formData.append('token', token);
    formData.append('env', process.env.REACT_APP_ENVIRONMENT); // If not pass env parameter, default env value is dev
    return await axios.post('/user/verify-re-captcha', formData, { headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Access-Control-Allow-Origin': 'content-type', 'device-id': `${deviceId}` } });
  } catch (error) {
    // eslint-disable-next-line no-restricted-syntax
    console.error(error);
    throw error;
  }
}
